import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

import { STORAGE_KEY_ASSISTANT_PANEL_SIZE } from '../constants/storage-keys.const';

import { AssistantSize } from './+store';


const ERLAUBTE_GROESSEN: readonly AssistantSize[] = ['small', 'large'];


/**
 * Merkt sich die zuletzt gewählte Panel-Größe im Browser.
 *
 * Nur lokal, weil die Größe eine Vorliebe am Arbeitsplatz ist und dem Nutzer
 * nicht auf ein fremdes Gerät folgen soll.
 *
 * Jeder Zugriff liegt in try/catch, weil schon das Ansprechen von
 * `localStorage` wirft, wenn der Browser den Speicher sperrt (private Fenster,
 * blockierte Website-Daten) - das darf das Umschalten nicht stören.
 */
@Injectable({ providedIn: 'root' })
export class AssistantSizeStorageService {

  private readonly _logger = inject(NGXLogger);

  /**
   * Der gelesene Wert wird geprüft, statt ihm zu vertrauen: Im Speicher kann
   * ein veralteter oder fremder Eintrag unter demselben Schlüssel stehen.
   */
  read(): AssistantSize | undefined {
    try {
      const wert = localStorage.getItem(STORAGE_KEY_ASSISTANT_PANEL_SIZE);
      return ERLAUBTE_GROESSEN.find(groesse => groesse === wert);
    } catch (e) {
      this._logger.info('Could not read assistant panel size', e);
      return undefined;
    }
  }

  write(
    size: AssistantSize,
  ): void {
    try {
      localStorage.setItem(STORAGE_KEY_ASSISTANT_PANEL_SIZE, size);
    } catch (e) {
      this._logger.info('Could not save assistant panel size', e);
    }
  }

}
